
      <!-- <div class="container"> -->
      <div class="dropzone" [ngClass]="{'shake': fileover}" (dragover)="onDragover($event)" (dragleave)="onDragLeave($event)" (drop)="ondrop($event)">
        <input type="file" #fileDropref id="fileDropRef" multiple (change)="onFileSelected($event)"/>
        <img src="assets/img/dnd/ic-upload-file.svg" alt="" />
        <h3 [ngClass]="{'shake': fileover}">Drag and drop file here</h3>
        <h3>or</h3>
        <label for="fileDropRef">Browse for file</label>
      </div>
      <!-- </div> -->
    